import { IconComponentProps } from '../IconTypes';

const CheckmarkDouble = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.90066 15.5658C8.65847 15.8119 8.26003 15.8119 8.01785 15.5658L4.89246 12.4408C4.64832 12.1986 4.64832 11.8002 4.89246 11.558C5.13621 11.3119 5.53191 11.3119 5.77605 11.558L8.45925 14.2416L14.2678 8.43262C14.51 8.18848 14.9085 8.18848 15.1507 8.43262C15.3968 8.67637 15.3968 9.07207 15.1507 9.31621L8.90066 15.5658Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M19.1076 8.48015C19.3517 8.72423 19.3517 9.11996 19.1076 9.36404L12.9204 15.5512C12.6763 15.7953 12.2806 15.7953 12.0365 15.5512C11.7924 15.3071 11.7924 14.9114 12.0365 14.6673L18.2237 8.48015C18.4678 8.23608 18.8635 8.23608 19.1076 8.48015Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export default CheckmarkDouble;
